'use client'

import styled from 'styled-components'

export const StyledBody = styled.body`
    margin: 0;
    padding: 0;

    * {
        box-sizing: border-box;
    }

    .radix-themes {
        --cursor-button: pointer;
        --cursor-checkbox: pointer;
        --cursor-link: pointer;
        --cursor-menu-item: pointer;
        --cursor-radio: pointer;
        --cursor-slider-thumb: grab;
        --cursor-slider-thumb-active: grabbing;
        --cursor-switch: pointer;
    }
`

export const LoadingSpinner = styled.div<{ $size: string }>`
    margin-inline: auto;
    width: ${props => props.$size};
    height: ${props => props.$size};
    border-radius: 50%;
    border: 11.5px solid;
    border-color: var(--gray-3);
    border-right-color: var(--gray-8);
    animation: spinner 1s infinite linear;

    @keyframes spinner {
        to {
            transform: rotate(1turn);
        }
    }
`
